import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  makeStyles,
  Select,
  MenuItem,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  withStyles,
  TablePagination,
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import {
  getDegree,
  getDegreeCourse,
  clearData,
  clearErrorMessage,
  clearErrorStatusCode,
} from "../../../reduxSlices/degreeSlice";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop/";
import Aux from "../../../hoc/Auxilliary";
import MessageIndicator from "../../SnackBar";
import { getCourseGroups } from "../../../reduxSlices/dashboardSlice";
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  "MuiAppBar-root": {
    zIndex: "98",
  },
  root: {
    textTransform: "captilize",
    color: "red",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const DegreePlan = (props) => {
  const dispatch = useDispatch();
  const [degree, setDegree] = useState([]);
  const [studentId, setStudentId] = useState(undefined);
  const [tableMapData, setTableMapData] = useState([]);
  const [groupCourses, setGroupCourses] = useState([]);
  const [value, setValue] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const classes = useStyles();
  const [selectedDegree, setSelectedDegree] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const degreeData = useSelector((state) => state.degreeData.degree);
  const degreeCoursesData = useSelector(
    (state) => state.degreeData.degreeCourses,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );

  const errorMessage = useSelector((state) => state.degreeData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.degreeData.errorStatusCode,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.degreeData.dataFetchingStatus,
  );

  useEffect(() => {
    if (degreeCoursesData?.requiredCourses?.length === 0) {
      setTableMapData([]);
    }
    if (degreeCoursesData?.groupCourses?.length === 0) {
      setGroupCourses([]);
    }
    if (
      degreeCoursesData.requiredCourses &&
      degreeCoursesData.requiredCourses.length
    ) {
      let degreeCourses = [...degreeCoursesData?.requiredCourses];
      setTableMapData(
        degreeCourses.sort(
          (a, b) => parseFloat(a.ses_order) - parseFloat(b.ses_order),
        ),
      );
    }
    if (
      degreeCoursesData.groupCourses &&
      degreeCoursesData.groupCourses.length > 0
    ) {
      setGroupCourses(degreeCoursesData.groupCourses);
    }
  }, [degreeCoursesData, selectedDegree]);
  useEffect(() => {
    if (applicantStatus.ses_applicantstatus) {
      setStudentId(applicantStatus.ses_applicantstatus.ses_studentid);
      dispatch(getDegree(applicantStatus.ses_applicantstatus.ses_studentid));
    }
  }, [applicantStatus]);
  useEffect(() => {
    if (!degreeData.length) {
      setDegree(degreeData);
    }
  }, [degreeData]);
  useEffect(() => {
    if (selectedDegree && studentId) {
      dispatch(getDegreeCourse({ degreeId: selectedDegree, studentId }));
    }
  }, [selectedDegree]);
 
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);
  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };
  useEffect(() => {
    return () => {
      dispatch(clearData());
    };
  }, []);
  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tableData = "";
  if (tableMapData.length > 0) {
    tableData = tableMapData
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((degreeCourse) => {
        return (
          <StyledTableRow>
            <StyledTableCell align="left">
              {degreeCourse.ses_course}
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse.ses_coursename}
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse.ses_order}
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse.ses_creditsavailable
                ? degreeCourse.ses_creditsavailable.toFixed(2)
                : degreeCourse.ses_creditsavailable}
            </StyledTableCell>
            <StyledTableCell align="left">
              {
                degreeCourse[
                  "ses_credittype@OData.Community.Display.V1.FormattedValue"
                ]
              }
            </StyledTableCell>
            <StyledTableCell align="left">
              {
                degreeCourse[
                  "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                ]
              }
            </StyledTableCell>
            <StyledTableCell align="left">
              {degreeCourse["ses_gradereceived"]}
            </StyledTableCell>
          </StyledTableRow>
        );
      });
  }

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <FormControl className={classes.formControl}>
        <InputLabel id="degree-plan">Degree Plan </InputLabel>
        <Select
          labelId="degree-plan"
          id="degree-plan"
          value={selectedDegree}
          defaultValue=""
          disabled={degreeData.length === 0}
          onChange={(event) => setSelectedDegree(event.target.value)}
        >
          <MenuItem value="" style={{ display: "none" }}></MenuItem>
          {degreeData.map((data) => (
            <MenuItem key={data.ses_degreeplanid} value={data.ses_degreeplanid}>
              {data.ses_certificationprogramname}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <AppBar position="static" classes={{ root: classes["MuiAppBar-root"] }}>
        <Tabs value={value} onChange={handleChange} aria-label="courses">
          <Tab label="Required Degree Courses" {...a11yProps(0)} />
          <Tab
            label="Degree Course Groups"
            disabled={!selectedDegree || dataFetchingStatus}
            {...a11yProps(1)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <TableContainer
          component={Paper}
          style={{ minHeight: "46.5vh", marginBottom: "10px" }}
        >
          <Table aria-label="required degree course">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left">Course</StyledTableCell>
                <StyledTableCell align="left">Course Name</StyledTableCell>
                <StyledTableCell align="left">Order</StyledTableCell>
                <StyledTableCell align="left">
                  Credits Available
                </StyledTableCell>
                <StyledTableCell align="left">Credit Type</StyledTableCell>
                <StyledTableCell align="left">Credits Earned</StyledTableCell>
                <StyledTableCell align="left">Grade</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>{tableData}</TableBody>
          </Table>
          <TablePagination
            style={{ textTransform: "capitalize" }}
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={tableMapData.length > 0 ? tableMapData.length : 0}
            rowsPerPage={rowsPerPage}
            classes={classes.root}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TableContainer>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {groupCourses.map((courses) => {
          return (
            <>
              <Typography component="h6">
                <span style={{ fontWeight: "bold" }}>
                  {courses.ses_coursegroupname}
                </span>
              </Typography>
              <Typography>
                <span style={{ fontWeight: "bold" }}>Credits Required</span> :{" "}
                {courses.ses_creditsrequired
                  ? courses.ses_creditsrequired.toFixed(2)
                  : courses.ses_creditsrequired}
              </Typography>
              <TableContainer
                component={Paper}
                style={{ minHeight: "46.5vh", marginBottom: "10px" }}
              >
                <Table aria-label="required degree course">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="left">Course</StyledTableCell>
                      <StyledTableCell align="left">
                        Course Name
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Credits Available
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Credit Type
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        Credits Earned
                      </StyledTableCell>
                      <StyledTableCell align="left">Grade</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>

                  {courses.data.length === 0 && (
                    <TableBody>
                      <div>No data available </div>
                    </TableBody>
                  )}
                  <TableBody>
                    {courses.data.map((degreeCourse) => {
                      return (
                        <StyledTableRow>
                          <StyledTableCell align="left">
                            {degreeCourse.ses_course}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {degreeCourse.ses_coursename}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {degreeCourse.ses_credits
                              ? degreeCourse.ses_credits.toFixed(2)
                              : degreeCourse.ses_credits}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {
                              degreeCourse[
                                "ses_credittype@OData.Community.Display.V1.FormattedValue"
                              ]
                            }
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {
                              degreeCourse[
                                "ses_earnedcredits@OData.Community.Display.V1.FormattedValue"
                              ]
                            }
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {degreeCourse["ses_gradereceived"]}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          );
        })}
      </TabPanel>
    </Aux>
  );
};

export default withRouter(DegreePlan);
